import { Data } from "@angular/router"

export interface OffertaB2c {
    serie: string
    numero: number
    descrizione: string
    data_inizio_validita: Date
    data_fine_validita: Date
    cod_tipo_offerta: number
    data_inizio_ordini: Date
    data_fine_ordini: Date
    riservata_a: number
    priorita: number
    flg_escludi_art_in_off: number
    negozi_attivi: string[]
    dettagli: OffertaDettaglioB2c[]
}

export enum TipoCodice {
    TotaleSpesa = 3,
    ListaArticoli = 0,
    Brand = 6,
    Fornitore = 5,
    Produttore = 100,
    FamigliaMeloni = 1,
    Stato = 2,
    brandFamiglia = 7
} // move in model class for promos or b2c

export interface OffertaDettaglioB2c {
    codice_smoll: string
    descrizione: string
    prezzo: number
    qta: number
    classe: number
    flg_canc_logica: number
    riga ?: number
    regola?: string
    sconto_perc?: number
    sconto_val?: number
    emme?: number
    tipo_codice?: number
    imp_limite?: number
    tipo_limite?: number
    punti?: number
    cod_fornitore?: number
    cod_brand?: number
    cod_produttore?: number
    cod_stato_articolo?: number
    cod_liv_1?: number
    cod_liv_2?: number
    cod_liv_3?: number
    cod_liv_4?: number

    tipo_codice_descrizione?: string
}

export interface ExcelVolantino{
    meloni: string
    smoll: string
    descrizione: string
    bt: number
    smo: number
    prezzoSmoll?: number
    prezzoPiume?: number
} 

export interface MultiOffertaDettaglioB2c{
    codice_smoll: string[]
    descrizione: string
    prezzo: number
    qta: number
    classe: number
    flg_canc_logica: number
    riga ?: number
    regola?: string
    sconto_perc?: number
    sconto_val?: number
    emme?: number
    tipo_codice?: number
    imp_limite?: number
    tipo_limite?: number
    punti?: number
    cod_fornitore?: number
    cod_brand?: number
    cod_produttore?: number
    cod_stato_articolo?: number
    cod_liv_1?: number
    cod_liv_2?: number
    cod_liv_3?: number
    cod_liv_4?: number

    tipo_codice_descrizione?: string
}

export interface ArticoloPromoScorta {
    codice_smoll:string
    qta:number
    prezzo: number
    classe: number
    serie:string
    numero:number
    riga:number
    regola:string
    flg_canc_logica:number;

}

export interface ExportPromoScorta {
    codice_smoll:string
    descrizione:string
    qta:number
    prezzo: number
    classe: number
}

enum eTipoOfferta
    {
        CEDI_SMOLL, CEDI_BEAUTYTU, CEDI_INGROSSO,
        SMIT_SMOLL, SMIT_PIUME, SMIT_BT, SMIT_MIX
    }

export interface RecuperoDatiPromo{
    numeroPromoCedi : number
    numeroPromoSmit : number
    
    }
export interface OffertaCedi{
    descrizione : string
    DataOffertaI : Date
    DataOffertaF : Date
    TipoOfferta : eTipoOfferta
    rArticoli:ArticoloCedi[]
    Clienti:string[];
}

export interface ArticoloCedi{
    codiceMeloni:string
    scontoPerBt:number
    scontoPerOff:number
}

export interface ArticoloPromoN {
    codice_smoll:string
    prezzo: number
    serie?:string
    numero?:number
    riga?:number
    flg_canc_logica:number;
    imp_limite: number
    tipo_limite: number
    punti?:number
    tipo_codice?:number
    cod_brand?: number

}
export interface Promo {
    serie:string
    numero:number
}
export interface Warning {
    cod_articolo:string
}
export interface selectArticleFlagPromoScorta {
    serie:string
    numero:number
    codice_smoll:string
    flag:string
}

export interface Shop {
    codice: string
    catena: string
    indirizzo: string
    cap: string
    comune: string
    provincia: string
    tipo: string
    flg_app_piucard: boolean
    flg_ordine_pezzo_sfuso: boolean
    qta_ordinabili: string
}

export interface AllShop { 
cap:string
catena:string
cod_cli_meloni:number
cod_pdv:string
cod_pdv_amus:number
cod_pdv_fidelity:number
comune:string
flg_iri:boolean
flg_piume:boolean
id:number
id_socio:number
id_socioNavigation:number
indirizzo:string
latitudine:number
longitudine:number
ord_auto_rif:string
provincia:string
}

export interface BuonoValore {
    cod_buono: number
    serie_offerta_emissione: string
    serie_offerta_utilizzo: string
    numero_offerta_emissione: number
    numero_offerta_utilizzo: number
    descrizione: string
    data_inizio_emissione?: Date
    data_fine_emissione?: Date
    data_inizio_utilizzo?: Date
    data_fine_utilizzo?: Date
    sconto?: Number
    stampa_coupon?: boolean
    fidelity: CouponValore[]
    fidelity_count: number;
    negozi_attivi: string[]
    flag_sconto_percentuale: boolean
    fidelity_attivati_count:number,
    fidelity_utlizzate_count:number,
    flag_genera_automaticamente_in_app:boolean
    flag_visibile_app_default:boolean
    flag_attivo_app_default:boolean

    // Info background task in corso (se presente)
    id_task?: number
    task_stato?: string
    task_messaggio?: string

}

export interface NotificaPush{
    id: number
    testo : string
    data_invio : Date
    elenco_clienti:string[]
    titolo:string
    risposta_invio ?:string
}
export interface EditNotificaPush{
    id: number
    testo : string
    data_invio : Date
    //elenco_clienti:string[]
    titolo:string
}

export interface UpdateShopPushNotificationRequest{
    id: number
    elenco_clienti:string[]
}


export interface CouponValore {
    numero_fidelity: string;
    barcode_coupon: string;
    cod_buono: number;
    data_rilascio: Date;
    utilizzato: boolean;
    data_utilizzo?: Date;
    sconto?: number;
    data_fine_utilizzo?: Date;
    cod_negozio_rilascio: string;
    cod_negozio_utilizzo: string;
    num_scontrino_utilizzo?: number;
    visibile_app?: boolean;
    attivo_app?: boolean;
    data_attivazione_app?: Date;
    flag_sconto_precentuale: boolean;
}

export interface CodeValue {
    codice: string;
    descrizione: string;
}

export interface fidelity{
    codice_fidelity: string
}

export interface fidelityNotification{
    codice_fidelity: fidelity[]
    typeFidelity: boolean
}

export interface allFidelity{
    codice_fidelity:string;
    nome:string;
    cognome:string;
    email:string;
    indirizzo:string;
    CAP:string;
    localita :string;
    provincia :string;
    nazione :string;
    data_nascita:Date;
    sesso:string;
    cellulare:string;
    flg_consenso1:boolean;
    flg_consenso2:boolean;
    flg_consenso3:boolean;
    data_ora_firma:Date;
    codice_negozio:string;
    ip_negozio:string;
    codice_release_informativa:number;
    versione_release_informativa:string;
    nome_file_immagine:string;
    data_aggiornamento?:Date;
    stato:string;
    classe?:number;
    flg_da_aggiornare?:boolean;
    data_registrazione?:Date;
    nomecognome:string;
    cognomenome:string;
    catena:string;
}

export interface blackListFidelity{
    codice_fidelity: string
}
export interface BlackListNewsletter{
    codice_fidelity: string
}

export interface FidelityFlag1NotBlackList{
    codice_fidelity: string;
    nome : string;
    cognome : string;
    email : string;
    catena : string;
}
export interface ShowAllBuoniValoreFidelity{
    numeroFidelity:string;
}

export interface ReportCoupon{
        numero_fidelity:string;
        cod_buono:number;
        descrizione:string;
        data_rilascio? :Date;
        utilizzato?: boolean;
        data_utilizzo?: Date;
        sconto?:number;
        data_fine_utilizzo?: Date;
        cod_negozio_rilascio?: string;
        cod_negozio_utilizzo? :String;
        comune?:String;
        num_scontrino_utilizzo?:Number;
        visibile_app:Boolean;
        attivo_app:Boolean;
        data_attivazione_app?:Date;
        flag_sconto_percentuale:Boolean;
        num_scontrino_rilascio?:number;
}
export interface GetReport{
        CodBuono:number;
}
export interface CheckArticoloPromo{
        serie:string;
        numero:number;
        descrizione:string;
        cod_articolo:string;
        qta_limite:number;
        sconto_perc:number;
        priorita:number;
        cod_tipo_offerta:number;
        data_inizio_validita:Date;
        data_fine_validita:Date;
}

export interface ArticoloThermoVirtuale{
    codice_articolo:string;
    descrizione:string;
    qta_cartone:number;
    qta_thermo:number;
    qta_virtuale:number;
}

export interface ArticoloStoricoPrezzo {
    Cod_negozio:string
    descrizione:string
    Cod_articolo:string
    Data_variazione: Date
    Prezzo: number
    Sconto:number
    Prezzo_finale:number
    Serie:string
    Numero:number
    Data_inizio:Date
    Data_fine:Date
    Sconto_perc:number
    Sconto_val:number
    Prezzo_imposto:number
    Data_stampa:Date
}

